<template>
<b-container v-if="this.getEstablecimiento">
  <h1 class="text-center">Registrar Solicitud de Alta Medica</h1>
  <h5>{{ (this.getEstablecimiento ? this.getEstablecimiento.DisplayNivelAsignado : '') }}</h5>
  <hr>
  <b-row>
    <b-col cols="12" lg="12">
      <form-buscar-personal></form-buscar-personal>
    </b-col>
  </b-row>

  <hr/>

  <b-row  v-if="notEmptyObject(this.Personal) && notEmptyObject(this.ListaCargoPersonal)">
    <b-col cols="12">
      <b-row>
        <b-col cols="12" lg="12">
          <b-button  variant="info" v-b-modal.modalRegistrarDiv size="sm" class="mb-2" v-if="this.ListaLicenciaCargoPersonalSeleccionado">
            <b-icon icon="calendar-plus"></b-icon> Registrar Solicitud de Alta Medica
          </b-button>
          <tabla-historial-solicitud-medica :seleccionable="true" :personal="this.Personal" ></tabla-historial-solicitud-medica>
        </b-col>
      </b-row>
    </b-col>
  </b-row>

  <b-modal
    v-if="notEmptyObject(this.Personal)"
    id="modalRegistrarDiv" ref="modal"
    hide-footer
    :title="modalRegistrar.title"
    size="lg"
    :header-bg-variant="modalRegistrar.headerBackground"
    header-text-variant="light">
    <registrar-solicitud-alta-medica-form
      v-on:form-solicitud-close="cerrarModal($event)"
      :personal="this.Personal"
      :licenciacargopersonal="this.ListaLicenciaCargoPersonal">
    </registrar-solicitud-alta-medica-form>
  </b-modal>
</b-container>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'

import RegistrarSolicitudAltaMedicaForm from './RegistrarSolicitudAltaMedicaForm.vue'

import TablaHistorialSolicitudMedica from '../../common/TablaHistorialSolicitudMedica.vue'
import TablaCargoPersonal from '../../common/TablaCargoPersonal.vue'
import FormBuscarPersonal from '../../common/FormBuscarPersonal.vue';


import { createHelpers } from 'vuex-map-fields';



const { mapFields: mapFormSolicitudAltaFields } = createHelpers({
  getterType: 'FormSolicitudAltaModule/getSolicitudAltaField',
  mutationType: 'FormSolicitudAltaModule/updateSolicitudAltaField',
});

const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});

export default {
  name: "RegistrarSolicitudAltaMedica",
  mixins: [errorhandler, swalerts],
  components: { RegistrarSolicitudAltaMedicaForm, TablaHistorialSolicitudMedica, FormBuscarPersonal, TablaCargoPersonal },
  computed: {
    ...mapGetters(['getEstablecimiento', 'isInRoleAdmin', 'isInRoleCoordinador', 'isInRoleEstablecimiento', 'isInRoleRecMedico']),
    ...mapFormSolicitudAltaFields(['TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaDesde', 'Observaciones', 'CantidadDias', 'ListaLicenciaCargoPersonalSeleccionado' ]),
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'Dni'])
  },

  data() {
    return {
      modalRegistrar:
      {
        headerBackground:'dark',
        title: '',
        content: '',
      },
      articuloSeleccionado:null,
      solicitudseleccionada:null,
      listacargosagregar:[],
      disabled:null,
      unidadId:'',
      nivelSolicitud : '',
      infoContacto: [],
      datosDocente: [],
      arregloLicencias: [],

      status: '',
      allCargosSelected:false,
      inputDniSearch: null
    }
  },
  mounted(){
    this.ListaLicenciaCargoPersonalSeleccionado = null;
  },
  methods: {
    articuloTrigger(articulo){
      console.log(articulo);
      if(articulo === 'Articulo 32'){
        console.log('mostrar formulario 32');
        this.ausenteDesdeVisible = false;
      }else{
        console.log('ocultar formulario 32');
        this.ausenteDesdeVisible = true;
      }
    },

    findLicenciaCargoPersonal() {
      return LicenciaCargoPersonalSvc.findl({
        Personal_Id: this.id,
        IncluyeCargoPersonal: true,
        IncluyeUsuarioCarga: true
      });
    },
    limpiar() {
      this.datosDocente = [];
      this.cantDiasSinTrabajar = 0;
    },
    cerrarModal(mensaje){
      if(mensaje){
        this.showSuccess(mensaje);
      }
      this.$refs.modal.hide();
    },
    obtenerFechaHasta() {
      var fechaRetornada = moment(this.txtFechaActual).add(this.txtCantidadDias, 'days').subtract(1, 'days').format();
      return fechaRetornada;
    },

    porcentajeDias() {
      return this.diasSinTrabajar;
    },
    cantDiasAnio() {
      return 365
    },



  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/RegistrarSolicitudAltaMedica.vue